import { render, staticRenderFns } from "./TelegramChatUnlinkConfirmModal.vue?vue&type=template&id=58c8cb1d&lang=pug&"
import script from "./TelegramChatUnlinkConfirmModal.vue?vue&type=script&lang=js&"
export * from "./TelegramChatUnlinkConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports